import React from "react";
import { withRouter } from "react-router-dom";
import CONSTANT from "./../../../constant";
import Loader from "./../../../component/common/Loader";
import { getAssignedEmployees } from "./../../../actions/AppraisalCycleAction";
import { formatDateDDMMYY } from "./../../../utils";

class AcceptingManagerReport extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      list: undefined,
      showLoader: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Accepting Authority - Assigned Employees - " + CONSTANT.organisation.name;
    this.loadList();
  }

  loadList = () => {
    this.setState({ showLoader: true });
    getAssignedEmployees({ roleType: "accepting" }).then((res: any) => {
      const list = res?.result || res || [];
      this.setState({ list, showLoader: false });
    });
  };

  navigateToReport = (employee: any) => {
    this.props.history.push({
      pathname: CONSTANT.component.aparAcceptingManagerForm1.url,
      state: {
        employeeCode: employee.employeeCode,
        employeeName: employee.employeeName,
        employeeNumber: employee.employeeNumber,
        effectiveFrom: employee.effectiveFrom,
        effectiveTo: employee.effectiveTo,
        kpiReportId: employee.kpiReportId || employee.kpi_report_id,
        ...this.buildManagerState(employee),
      },
    });
  };

  navigateToFullDetail = (employee: any) => {
    this.props.history.push({
      pathname: CONSTANT.component.aparEmployeeFullDetailView.url,
      state: {
        viewerRole: "accepting",
        employeeCode: employee.employeeCode,
        employeeName: employee.employeeName,
        employeeNumber: employee.employeeNumber,
        effectiveFrom: employee.effectiveFrom,
        effectiveTo: employee.effectiveTo,
        kpiReportId: employee.kpiReportId || employee.kpi_report_id,
        ...this.buildManagerState(employee),
      },
    });
  };

  buildManagerState = (employee: any) => ({
    reportingManagerCode: employee.reportingManagerCode,
    reportingManagerName: employee.reportingManagerName,
    reportingManagerNumber: employee.reportingManagerNumber,
    reviewingManagerCode: employee.reviewingManagerCode,
    reviewingManagerName: employee.reviewingManagerName,
    reviewingManagerNumber: employee.reviewingManagerNumber,
    acceptingAuthorityCode: employee.acceptingAuthorityCode,
    acceptingAuthorityName: employee.acceptingAuthorityName,
    acceptingAuthorityNumber: employee.acceptingAuthorityNumber,
  });

  render() {
    const { list, showLoader } = this.state;

    return (
      <div className="container-fluid mb-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card homedob">
              <div className="row">
                <div className="col-md-12">
                  <h1 className="page-title">
                    <i className="fa fa-check-square-o text-success mr-2" />
                    Accepting Authority - Assigned Employees
                  </h1>
                  <p className="text-muted">Employees assigned to you as Accepting Authority in the active appraisal cycle.</p>
                </div>
              </div>

              {showLoader && <Loader />}

              <div className="row mt-3">
                <div className="col-md-12">
                  <div className="table-container">
                    <div className="table-wrapper radius-4">
                      <table className="tablen">
                        <thead>
                          <tr className="text-center">
                            <th className="table-dark">#</th>
                            <th className="table-dark">Employee #</th>
                            <th className="table-dark">Name</th>
                            <th className="table-dark">Reporting Manager</th>
                            <th className="table-dark">Reviewing Manager</th>
                            <th className="table-dark">Accepting Authority</th>
                            <th className="table-dark">Effective From</th>
                            <th className="table-dark">Effective To</th>
                            <th className="table-dark">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {list === undefined && (
                            <tr>
                              <td colSpan={9} className="text-center">Loading...</td>
                            </tr>
                          )}
                          {list !== undefined && list.length === 0 && (
                            <tr>
                              <td colSpan={9} className="text-center">No employees assigned to you.</td>
                            </tr>
                          )}
                          {list !== undefined && list.map((item: any, index: number) => {
                            const rvmReportFilled = item.rvmReportFilled || item.rvm_report_filled || false;
                            const canFillReport = rvmReportFilled;

                            let fillReportTooltip = '';
                            if (!canFillReport) {
                              fillReportTooltip = 'Reviewing Manager has not submitted their report yet';
                            }

                            return (
                            <tr key={item.authorityId || index} className="text-center">
                              <td>{index + 1}</td>
                              <td>{item.employeeNumber}</td>
                              <td>{item.employeeName}</td>
                              <td>{item.reportingManagerName || '-'}</td>
                              <td>{item.reviewingManagerName || '-'}</td>
                              <td>{item.acceptingAuthorityName || '-'}</td>
                              <td>{item.effectiveFrom ? formatDateDDMMYY(item.effectiveFrom) : '-'}</td>
                              <td>{item.effectiveTo ? formatDateDDMMYY(item.effectiveTo) : 'Present'}</td>
                              <td>
                                <div className="d-flex justify-content-center gap-2">
                                  <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() => this.navigateToFullDetail(item)}
                                    title="View employee self-appraisal, Reporting Manager's & Reviewing Manager's assessments"
                                    style={{ visibility: rvmReportFilled ? 'visible' : 'hidden' }}
                                  >
                                    <i className="fa fa-file-text-o mr-1" />
                                    View Details
                                  </button>
                                  <button
                                    className="btn btn-sm submit-button"
                                    onClick={() => this.navigateToReport(item)}
                                    disabled={!canFillReport}
                                    title={fillReportTooltip}
                                  >
                                    <i className={`fa ${item.aaReportSubmitted ? 'fa-check' : 'fa-pencil'} mr-1`} />
                                    {item.aaReportSubmitted ? 'Submitted' : 'Fill Report'}
                                  </button>
                                </div>
                              </td>
                            </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(AcceptingManagerReport);
